import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ExpenseResponse } from 'src/app/models/expense-response.model'

@Injectable({
  providedIn: 'root',
})
export class ExpenseService {
  public static readonly expenseEndpoint = '/expense'

  constructor(private readonly http: HttpClient) {}

  getExpense(fundId: string): Observable<ExpenseResponse> {
    return this.http.get<ExpenseResponse>(
      `vmf/api/${fundId}`.concat(ExpenseService.expenseEndpoint),
    )
  }
}
